var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.context.classes.label,attrs:{"id":((_vm.context.id) + "_label"),"for":_vm.context.id},domProps:{"textContent":_vm._s(_vm.context.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }